// API Configuration
// En desarrollo usa el proxy de Vite (/api/v2 -> VITE_API_URL/api/v2)
// En producción usa la URL completa del backend
export const API_BASE_URL = import.meta.env.PROD
  ? `${import.meta.env.VITE_API_URL}/api/v2`
  : '/api/v2'

// URL base del backend (para iframes y recursos estáticos)
export const BACKEND_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000'

// URL pública para generar links cortos (puede diferir del API URL en producción)
export const SITE_URL = import.meta.env.VITE_SITE_URL || BACKEND_URL

// Legacy Django routes - these will be loaded in iframes until migrated
export const LEGACY_ROUTES = {
  cronograma: { path: '/multichannel/seguimiento/', title: 'Campañas' },
  registros: { path: '/registros/', title: 'Registros Externos' },
  whatsapp: { path: '/whatsapp/', title: 'WhatsApp' },
  contenido: { path: '/contenido/', title: 'Contenido' },
  clientes: { path: '/clientes/', title: 'Clientes' },
  multichannel: { path: '/multichannel/', title: 'Multicanal' },
} as const

export type LegacyRouteKey = keyof typeof LEGACY_ROUTES

// Tonal corporate colors
export const TONAL_COLORS = {
  blue: '#57a6d8',
  green: '#2fbc80',
  purple: '#8d82bc',
  pink: '#eb6587',
  yellow: '#f6c23e',
  gray: '#858796',
  dark: '#2b2b2b',
  secondary: '#404040',
} as const
